
export enum WpStatus {
    Publish = 0,
    Private = 1,
    Future = 2,
    Draft = 3,
    Pending = 4,
}